import { Card } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Clock, LogOut, Sparkles } from "lucide-react";

export default function PendingApproval() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const doLogout = async () => { await logout(); nav("/login"); };
  return (
    <div className="min-h-screen app-bg flex items-center justify-center p-6">
      <Card className="p-8 max-w-md w-full border border-[#E5E0D8] bg-white text-center" data-testid="pending-screen">
        <div className="mx-auto w-14 h-14 rounded-full bg-amber-100 flex items-center justify-center mb-4">
          <Clock className="w-6 h-6 text-amber-700" />
        </div>
        <h1 className="font-display text-xl font-bold">Menunggu Verifikasi Owner</h1>
        <p className="text-sm text-[#5C6066] mt-2">
          Akun Anda <span className="font-medium">{user?.name}</span> telah didaftarkan dengan sukses.
          Owner akan meninjau divisi dan peran yang diminta sebelum memberikan akses ke sistem.
        </p>
        <div className="mt-6 text-left text-sm bg-[#FAF6EE] rounded p-4 space-y-1 border border-[#E5E0D8]">
          <div><span className="text-[#8C9096]">Divisi diminta:</span> {user?.requested_division_id || "-"}</div>
          <div><span className="text-[#8C9096]">Peran diminta:</span> {user?.requested_role || "-"}</div>
        </div>
        <Button onClick={doLogout} variant="outline" className="mt-6" data-testid="btn-pending-logout">
          <LogOut className="w-4 h-4 mr-1.5" /> Keluar
        </Button>
      </Card>
    </div>
  );
}
